import { ReactNode } from 'react'

import { Panel } from '@/ui/atoms/panel/Panel'

interface WalletPanelContentProps {
  children: ReactNode
}

export function WalletPanelContent({ children }: WalletPanelContentProps) {
  return <Panel className="flex flex-col">{children}</Panel>
}
